var React = require('react');

function Star (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("linearGradient",{"id":"star-gradient","x1":"0%","y1":"0%","y2":"0%"},[React.createElement("stop",{"offset":"0%","stopColor":"#FF9619","key":0}),React.createElement("stop",{"offset":"100%","stopColor":"#F6C164","key":1})])),React.createElement("polygon",{"fill":"url(#star-gradient)","points":"16 5.829 10.472 5.026 8 .017 5.528 5.026 0 5.829 4 9.728 3.056 15.233 8 12.634 12.944 15.233 12 9.728","transform":"translate(0 .38)","key":1})]);
}

Star.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = Star;

Star.default = Star;
